import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';

export const catalogGraphFr = createTranslationMessages({
  ref: catalogGraphTranslationRef,
  full: true,
  messages: {
    'catalogGraphCard.title': 'Relations',
    'catalogGraphCard.deepLinkTitle': 'Voir le graphe',
    'catalogGraphPage.title': 'Graphe du catalogue',
    'catalogGraphPage.filterToggleButtonTitle': 'Filtres',
    'catalogGraphPage.supportButtonDescription':
      'Commencez à suivre votre composant en l’ajoutant au catalogue logiciel.',
    'catalogGraphPage.simplifiedSwitchLabel': 'Simplifié',
    'catalogGraphPage.mergeRelationsSwitchLabel': 'Fusionner les relations',
    'catalogGraphPage.zoomOutDescription':
      'Utilisez le pincement et le zoom pour vous déplacer dans le diagramme. Cliquez pour changer le nœud actif, cliquez avec Maj pour accéder à l’entité.',
    'catalogGraphPage.curveFilter.title': 'Courbe',
    'catalogGraphPage.curveFilter.curveStepBefore': 'Palier avant',
    'catalogGraphPage.curveFilter.curveMonotoneX': 'Monotone X',
    'catalogGraphPage.directionFilter.title': 'Direction',
    'catalogGraphPage.directionFilter.leftToRight': 'De gauche à droite',
    'catalogGraphPage.directionFilter.rightToLeft': 'De droite à gauche',
    'catalogGraphPage.directionFilter.topToBottom': 'De haut en bas',
    'catalogGraphPage.directionFilter.bottomToTop': 'De bas en haut',
    'catalogGraphPage.maxDepthFilter.title': 'Profondeur maximale',
    'catalogGraphPage.maxDepthFilter.inputPlaceholder': '∞ Infinie',
    'catalogGraphPage.maxDepthFilter.clearButtonAriaLabel':
      'effacer la profondeur maximale',
    'catalogGraphPage.selectedKindsFilter.title': 'Types',
    'catalogGraphPage.selectedRelationsFilter.title': 'Relations',
  },
});
